import api from '@/api'

export interface FrequentRoute {
  route: string
  route_name?: string | null
  visit_count: number
  last_visited_at: string
  score: number
}

export interface RecentDocument {
  id: string
  occurred_at: string
  type: string
  subject: string
  amount: number
  status: string
  route: string
}

export const ActivityApi = {
  registerRoute: (route: string, routeName?: string | null) =>
    api.post('/activity/routes', {
      route,
      route_name: routeName || null
    }),
  frequentRoutes: (limit = 30) =>
    api.get<FrequentRoute[]>('/activity/routes/frequent', {
      params: { limit }
    }).then(response => response.data),
  recentDocuments: (limit = 10) =>
    api.get<RecentDocument[]>('/activity/documents/recent', {
      params: { limit }
    }).then(response => response.data)
}
